import React from 'react';
import { useTranslation } from 'react-i18next';
import { SiCheckmarx } from "react-icons/si";
import FeatureCards from "../../../../components/FeatureCards/FeatureCards";
import CTA from "../../../../components/Constant/cta/CTA";
import TimelineSection from "../../../../components/TimelineSection/TimelineSection";
import WhySection from "../../../../components/WhySection/WhySection";
import LocationTimeline from "../../../../components/LocationTimeline/LocationTimeline";
import ServiceCards from "../../../../components/ServiceCards/ServiceCards";
import IntroSection from "../../../../components/IntroSection/IntroSection";
import FAQList from "../../../../components/Constant/FAQCard/FAQCard";
import Testimonials from "../../../../components/Constant/Testimonials/Testimonials";
import SEO from "../../../../utils/SEO";

const TIMELINE_STYLES = [
    { background: "#EFF6FF", border: "#DBEAFE" },
    { background: "#FEF3C7", border: "#FDE68A" },
    { background: "#F3E8FF", border: "#E9D5FF" },
];

const GamingLicenseServices = () => {
    const { t } = useTranslation();
    const tp = (k, d) => t(`pages.gaming-license-services.${k}`, d);
    const obj = (k) => tp(k, { returnObjects: true });
    const withIcon = (k, icon) => (obj(k) || []).map((item) => ({ ...item, icon }));

    return (
        <main className='main'>
            <SEO
                title={tp('seo.title')}
                description={tp('seo.description')}
                keywords={tp('seo.keywords')}
                url="/gaming-license-services"
            />

            <IntroSection
                title={tp('intro.title')}
                subtitle={tp('intro.subtitle')}
                description={tp('intro.description')}
                badges={obj('intro.badges')}
                buttonText={tp('intro.button')}
                buttonLink="/contact"
                imageSrc="https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=800&h=600&fit=crop"
                imageAlt={tp('intro.imageAlt')}
            />

            <section className='section'>
                <div className="container">
                    <WhySection
                        title={tp('why.title')}
                        subtitle={tp('why.subtitle')}
                        blocks={[
                            { subtitle: tp('why.withoutSubtitle'), items: withIcon('why.without', "❌") },
                            { subtitle: tp('why.withSubtitle'), items: withIcon('why.with', "✔️") }
                        ]}
                    />

                    <FeatureCards
                        title={tp('types.title')}
                        features={obj('types.items')}
                    />

                    <LocationTimeline
                        title={tp('jurisdictions.title')}
                        item={obj('jurisdictions.items')}
                        end={tp('jurisdictions.end')}
                    />

                    {/* Services */}
                    <ServiceCards
                        title={tp('support.title')}
                        services={withIcon('support.items', SiCheckmarx)}
                    />

                    {/* Timeline */}
                    <TimelineSection
                        title={tp('timeline.title')}
                        items={(obj('timeline.items') || []).map((item, i) => ({ ...item, ...TIMELINE_STYLES[i] }))}
                    />

                    <FAQList data={obj('faq.items')} title={tp('faq.title')}/>

                    <Testimonials
                        title={tp('testimonials.title')}
                        testimonials={obj('testimonials.items')}
                    />

                    {/* Final CTA */}
                    <CTA title={tp('cta.title')}
                         description={tp('cta.description')}
                         buttonText={tp('cta.button')}
                         buttonLink='/quote'
                    />
                </div>
            </section>
        </main>
    );
};

export default GamingLicenseServices;
